import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProcedureReport } from '../models/procedure-report.model';

@Injectable({
  providedIn: 'root'
})
export class ProcedureReportService {
  private url: string = environment.urls.baseApiUrl + '/ProcedureReports/';

  constructor(
    private http: HttpClient) { }

  public read(): Observable<ProcedureReport[]> {
    return this.http.get<ProcedureReport[]>(this.url);
  }

  public readByUserID(userID: number): Observable<ProcedureReport[]> {
    return this.http.get<ProcedureReport[]>(this.url + userID);
  }

  /**
   * Starts the manager procedure-report email job from the restricted menu action.
   */
  generateManagersEmails(): Observable<void> {
    // Use the controller PATCH endpoint so manual tests run the same workflow as the scheduler.
    return this.http.patch<void>(this.url, null);
  }

}
